import PropTypes from 'prop-types';
import React from 'react';

import { Label } from '@commons/utils/styledLibraryComponents';

import theme from '@theme';

const BADGE_WIDTH = '24px';

/**
 * Catalog product count badge: black outline when the catalog has products, red when it is empty
 * so clients without any catalog product stand out in the lists.
 */
const ProductCountBadge = (props) => {
  const { productCount } = props;

  const count = productCount || 0;
  const badgeColor = count > 0 ? theme.colors.greys.darkest : theme.colors.infoRed;

  return (
    <Label background={badgeColor} color={badgeColor} type={'outline'} width={BADGE_WIDTH}>
      {String(count)}
    </Label>
  );
};

ProductCountBadge.propTypes = {
  productCount: PropTypes.number,
};

ProductCountBadge.defaultProps = {
  productCount: 0,
};

export default ProductCountBadge;
